import GET_ARTICLES from '../plugins/getArticles';

const [ w, d, content ] = [ window, document, 'recruit' ];


const init = () => {

  // 応募要項一覧
  $.when( w.load['recruit06'] ).then( () => {
    let makeItem = item =>  {
      console.log(item)
      return $(`
      <a href="${item.href}" class="requirements-item">
        <div class="requirements-item__img">
          <div class="requirements-item__img-cover" style="background-image:url(${item.thumb})">
            <img src="${item.thumb}" alt="${item.title}" width="400" loading="lazy">
          </div>
        </div>
        <div class="requirements-item__body">
          <span class="subject">${item.title.str_truncate(30)}</span>
          <span class="desc">${item.desc.str_truncate(30)}</span>
        </div>
      </a>
    `)[0];
    }
    GET_ARTICLES( '.requirements-list[data-plugin="getArticles"]', { makeItem });
  });

}

const detail_init = async post_id => {
  let articles = await $.getArticles({ content, post_status: 'all' })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == post_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // 詳細書き換え
  if( d.body.classList.contains('is--detail') ){
    let the_id = document.body.getAttribute('class').replace(/^.+is--article-([\d]+)(.+)?$/,'$1')
    let codingPageArr = [1,2,3,4,5,6,7]
    const is_userEdit = () => codingPageArr.indexOf( parseInt( the_id ) ) == -1;

    // ユーザー更新ページ　クラス付与
    if( is_userEdit() )  $('body').addClass('is-useredit');
  }

  $('.element_detail').each( ( i, elm_detail ) => {
    if( the_article.category && the_article.category.id == 1 ) {
      //応募要項カテゴリの記事にコンテンツヘッダーを挿入
      const $head = $(`
        <section class="mainImg">
          <div class="mainImgInner">
            <h2><span>応募要項</span></h2>
          </div>
        </section>
      `);
      $('.element_detail > .title, .detail_title').remove();
      $('.element_detail .entry figure.imgbox').remove();
      $head.prependTo( elm_detail );

      //応募要項カテゴリの記事にフッターHTMLを挿入
      const detailFoot = $.get('/asset/html/recruit-detail-foot.html');
      detailFoot.done( html => $('.element_detail .entry').append(html) );
    }
  });

}

export default function RECRUIT() {
  $(init)
  if( w.query_string('article') ) detail_init( w.query_string('article') )
}